var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit, Injector } from '@angular/core';
import { SeoAwareBaseComponent } from '../common-theme/seo/seo-aware-base.component';
import { ListTrackingService } from '../common-theme/utils/list-tracking.service';
import { EmbedVideoService } from '../common-theme/index';
var ConstructionComponent = /** @class */ (function (_super) {
    __extends(ConstructionComponent, _super);
    function ConstructionComponent(embedService, listTrackingService, injector) {
        var _this = _super.call(this, injector) || this;
        _this.embedService = embedService;
        _this.listTrackingService = listTrackingService;
        _this.injector = injector;
        _this.images1 = [];
        _this.images2 = [];
        _this.images3 = [];
        _this.videos = [
            'https://www.youtube.com/watch?v=gSnMwYOvABg'
        ];
        _this.videos = _this.videos.map(function (url) { return _this.embedService.embed(url); });
        _this.images1 = Array.from(Array(6).keys()).map(function (el) {
            return {
                url: "/assets/images/gallery/construction/1/" + (el + 1) + ".jpg",
                width_560_url: "/assets/images/gallery/construction/1/" + (el + 1) + ".jpg",
                width_320_url: "/assets/images/gallery/construction/1/" + (el + 1) + ".jpg"
            };
        });
        _this.images2 = Array.from(Array(20).keys()).map(function (el) {
            return {
                url: "/assets/images/gallery/construction/2/" + (el + 1) + ".jpeg",
                width_560_url: "/assets/images/gallery/construction/2/" + (el + 1) + ".jpeg",
                width_320_url: "/assets/images/gallery/construction/2/" + (el + 1) + ".jpeg"
            };
        }).reverse();
        _this.images3 = Array.from(Array(13).keys()).map(function (el) {
            return {
                url: "/assets/images/gallery/construction/3/" + (el + 1) + ".jpg",
                width_560_url: "/assets/images/gallery/construction/3/" + (el + 1) + ".jpg",
                width_320_url: "/assets/images/gallery/construction/3/" + (el + 1) + ".jpg"
            };
        }).reverse();
        return _this;
    }
    ConstructionComponent.prototype.ngOnInit = function () {
        this.setTitle('Șantierul Romanescu Park Residence');
    };
    return ConstructionComponent;
}(SeoAwareBaseComponent));
export { ConstructionComponent };



// WEBPACK FOOTER //
// ./src/app/downtown-life/construction.component.ts.pre-build-optimizer.js